<template>
  <div class="profile ">
    <v-container fluid class="pt-0">
      <v-card class="pa-2 mb-3 card-r pb-2 shadow-1">
        <v-toolbar class="primary mb-3 card-r pl-3 text-white">
          <div class="text-xs-left f-20">My Profile</div>
        </v-toolbar>
      <!-- <v-layout row class="pb-2 px-0">
        <v-flex class>
          <v-tabs
            slot="extension"
            class="white elevation-1 ProfileTabs"
            v-model="profileTabs"
            fixed-tabs
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab href="#personal" class="primary--text">Personal</v-tab>

            <v-tab href="#subscription" class="primary--text">Subscription</v-tab>

            <v-tab href="#sales" class="primary--text">Sales</v-tab>
          </v-tabs>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-tabs-items v-model="profileTabs" class="white elevation-1">
            <v-tab-item id="personal" key="1">
              <personal/>
            </v-tab-item>
            <v-tab-item id="subscription" key="2">
              <subscription/>
            </v-tab-item>
            <v-tab-item id="sales" key="3">
              <sales/>
            </v-tab-item>
          </v-tabs-items>
        </v-flex>
      </v-layout> -->
      <!--<v-card>-->
 <personal/>
      <!--</v-card>-->
      </v-card>
    </v-container>
  </div>
</template>
<script>
/* eslint-disable */
import Personal from "./Personal";
import Subscription from "./Subscription";
import Sales from "./Sales";
export default {
  name: "profile",
  data: () => ({
    profileTabs: null
  }),
  components: { Personal, Subscription, Sales }
};
</script>



// WEBPACK FOOTER //
// src/pages/pages/profile/Profile.vue